import React from "react";

const Account = () => {
  return (
    <div className="shadow-md shadow-tableColor overflow-hidden rounded-lg">
      <div className="w-full flex justify-between items-center bg-tableColor rounded-t-md rounded-r-md px-5 py-4">
        <div className="text-bodyColor text-lg font-Inter font-bold break-words">
          Account
        </div>
        <div className="text-opaBodyColor text-sm font-Inter font-medium break-words">
          Connect Wallet
        </div>
      </div>
      <div className="flex flex-1 justify-center items-center pt-5 bg-tableBodyColor truncate px-4 2xl:px-6">
        <div className="w-1/3 px-4 py-3 border border-opaBorderColor border-solid rounded-lg">
          <div className="text-opaBodyColor text-center text-sm font-Inter font-medium break-words">
            APY
          </div>
          <div className="text-bodyColor text-center text-lg font-Inter font-bold break-words">
            0.00%
          </div>
        </div>
        <div className="w-1/3 mx-2 2xl:mx-3 px-3 py-3 border border-opaBorderColor border-solid rounded-lg">
          <div className="text-opaBodyColor text-center text-sm font-Inter font-medium break-words">
            Borrowed
          </div>
          <div className="text-bodyColor text-center text-lg font-Inter font-bold break-words">
            0.00%
          </div>
        </div>
        <div className="w-1/3 px-2 py-3 border border-opaBorderColor border-solid rounded-lg">
          <div className="text-opaBodyColor text-center text-sm font-Inter font-medium break-words">
            Risk Factor
          </div>
          <div className="text-bodyColor text-center text-lg font-Inter font-bold break-words">
            0.00%
          </div>
        </div>
      </div>
      <div className="flex flex-1 justify-between pt-2 bg-tableBodyColor truncate px-4 2xl:px-6">
        <div className="text-bodyColor text-lg font-Inter font-bold break-words">
          Borrowing Power
        </div>
        <div className="text-[#FF6959] text-lg font-Inter font-semibold break-words">
          22.34%
        </div>
      </div>
      <div className="flex px-4 2xl:px-6 pt-2 bg-tableBodyColor">
        <div className="w-3/5 h-2 bg-[#66FF88] rounded-full"></div>
        <div className="w-2/5 h-2 bg-white rounded-full"></div>
      </div>
      <div className="flex flex-1 justify-between items-center px-4 2xl:px-6 pt-2 bg-tableBodyColor">
        <div className="text-opaBodyColor text-sm font-Inter font-medium break-words">
          Available
        </div>
        <div className="text-bodyColor text-lg font-Inter font-semibold break-words">
          65.45%
        </div>
      </div>
      <div className="flex flex-1 justify-between items-center px-4 2xl:px-6 pt-2 pb-5 bg-tableBodyColor">
        <div className="text-opaBodyColor text-sm font-Inter font-medium break-words">
          Risk Factor
        </div>
        <div className="text-riskColor text-lg font-Inter font-semibold break-words">
          45.65%
        </div>
      </div>
    </div>
  );
};

export default Account;
